import styled, { createGlobalStyle } from 'styled-components';

import { ThemeType } from '../index';

interface IProps {
  inline?: boolean;
}

const GlobalStyle = createGlobalStyle<{ theme: ThemeType }>`
  html,
  body {
    padding: 0;
    margin: 0;
    font-family: hurmeGeometricSans3, sans-serif;
  }

  h1, h2, h3, h4, h5, p {
    padding: 0;
    margin: 0;
  }

  button, label {
    user-select: none;
  }

  a, .link {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  ul {
    list-style: none;
  }

  * {
    box-sizing: border-box;
  }

  @font-face {
    font-family: hurmeGeometricSans3;
    src: url('/static/fonts/HurmeGeometricSans3-Black.eot');
    src: local('HurmeGeometricSans3 Black'), local('HurmeGeometricSans3-Black'),
    url('/static/fonts/HurmeGeometricSans3-Black.eot?#iefix') format('embedded-opentype'),
    url('/static/fonts/HurmeGeometricSans3-Black.woff2') format('woff2'),
    url('/static/fonts/HurmeGeometricSans3-Black.woff') format('woff'),
    url('/static/fonts/HurmeGeometricSans3-Black.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: hurmeGeometricSans3;
    src: url('/static/fonts/HurmeGeometricSans3-Bold.eot');
    src: local('HurmeGeometricSans3 Bold'), local('HurmeGeometricSans3-Bold'),
    url('/static/fonts/HurmeGeometricSans3-Bold.eot?#iefix') format('embedded-opentype'),
    url('/static/fonts/HurmeGeometricSans3-Bold.woff2') format('woff2'),
    url('/static/fonts/HurmeGeometricSans3-Bold.woff') format('woff'),
    url('/static/fonts/HurmeGeometricSans3-Bold.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: hurmeGeometricSans3;
    src: url('/static/fonts/HurmeGeometricSans3-Regular.eot');
    src: local('HurmeGeometricSans3 Regular'), local('HurmeGeometricSans3-Regular'),
    url('/static/fonts/HurmeGeometricSans3-Regular.eot?#iefix') format('embedded-opentype'),
    url('/static/fonts/HurmeGeometricSans3-Regular.woff2') format('woff2'),
    url('/static/fonts/HurmeGeometricSans3-Regular.woff') format('woff'),
    url('/static/fonts/HurmeGeometricSans3-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: hurmeGeometricSans3;
    src: url('/static/fonts/HurmeGeometricSans3-SemiBold.eot');
    src: local('HurmeGeometricSans3 SemiBold'), local('HurmeGeometricSans3-SemiBold'),
    url('/static/fonts/HurmeGeometricSans3-SemiBold.eot?#iefix') format('embedded-opentype'),
    url('/static/fonts/HurmeGeometricSans3-SemiBold.woff2') format('woff2'),
    url('/static/fonts/HurmeGeometricSans3-SemiBold.woff') format('woff'),
    url('/static/fonts/HurmeGeometricSans3-SemiBold.ttf') format('truetype');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: hurmeGeometricSans3;
    src: url('/static/fonts/HurmeGeometricSans3-RegularObl.eot');
    src: local('HurmeGeometricSans3 RegularOblique'), local('HurmeGeometricSans3-RegularObl'),
    url('/static/fonts/HurmeGeometricSans3-RegularObl.eot?#iefix') format('embedded-opentype'),
    url('/static/fonts/HurmeGeometricSans3-RegularObl.woff2') format('woff2'),
    url('/static/fonts/HurmeGeometricSans3-RegularObl.woff') format('woff'),
    url('/static/fonts/HurmeGeometricSans3-RegularObl.ttf') format('truetype');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: hurmeGeometricSans3;
    src: url('/static/fonts/HurmeGeometricSans3-BoldObl.eot');
    src: local('HurmeGeometricSans3 BoldOblique'), local('HurmeGeometricSans3-BoldObl'),
    url('/static/fonts/HurmeGeometricSans3-BoldObl.eot?#iefix') format('embedded-opentype'),
    url('/static/fonts/HurmeGeometricSans3-BoldObl.woff2') format('woff2'),
    url('/static/fonts/HurmeGeometricSans3-BoldObl.woff') format('woff'),
    url('/static/fonts/HurmeGeometricSans3-BoldObl.ttf') format('truetype');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: hurmeGeometricSans3;
    src: url('/static/fonts/HurmeGeometricSans3-Light.eot');
    src: local('HurmeGeometricSans3 Light'), local('HurmeGeometricSans3-Light'),
    url('/static/fonts/HurmeGeometricSans3-Light.eot?#iefix') format('embedded-opentype'),
    url('/static/fonts/HurmeGeometricSans3-Light.woff2') format('woff2'),
    url('/static/fonts/HurmeGeometricSans3-Light.woff') format('woff'),
    url('/static/fonts/HurmeGeometricSans3-Light.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
  html {
    background-color: #253343;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #445A74;
    border-radius: 8px;
  }
  
  #SfxPopper .FIE_crop-presets-menu .SfxMenuItem-wrapper {
    display: none;
  }
  #SfxPopper .FIE_crop-presets-menu .SfxMenuItem-wrapper:last-child,
  #SfxPopper .FIE_crop-presets-menu .SfxMenuItem-wrapper:nth-child(3)
  {
   .SfxMenuItem-root div {
      display: none;
    }
    display: block;
  }
  
 #SfxPopper .FIE_image-tool-gallery div div{
    //background-color: #FFF;
   border-color: rgba(255,255,255, 0.2);
   padding: 0 8px;
   
   img {
     object-fit: contain;
      
   }
  } 
  
  #SfxPopper .hngSYE{
    background-color: #1C2631;
    box-shadow: none  }
  
  .FIE_root * {
    font-family: hurmeGeometricSans3 !important;
  }
`;
export default GlobalStyle;

export const Container = styled.div`
  width: 1224px;
  margin: 0 auto;

  @media (min-width: 1440px) {
    width: 1224px;
  }
  @media (min-width: 1600px) {
    // width: 1366px;
    width: 1224px;
  }
  @media (min-width: 1920px) {
    // width: 1920px;
    width: 1224px;
  }
`;

export const GridWrapper = styled(Container)`
  display: grid;
  grid-template-columns: repeat(12, [col] 1fr);
  grid-column-gap: 16px;
`;

export const H1 = styled.h1`
  font-weight: bold;
  font-family: Poppins, Helvetica Neue, 'sans-serif';
  font-size: ${(props) => props.theme.baseFontSize + 108}px;
`;

export const H2 = styled.h2`
  font-weight: bold;
  font-family: Poppins, Helvetica Neue, 'sans-serif';
  font-size: ${(props) => props.theme.baseFontSize + 76}px;
`;
export const H3 = styled.h3`
  font-weight: bold;
  font-family: Poppins, Helvetica Neue, 'sans-serif';
  font-size: ${(props) => props.theme.baseFontSize + 58}px;
`;
export const H4 = styled.h4`
  font-weight: bold;
  font-family: Poppins, Helvetica Neue, 'sans-serif';
  font-size: ${(props) => props.theme.baseFontSize + 37}px;
`;

export const H5 = styled.h5`
  font-weight: bold;
  font-family: Poppins, Helvetica Neue, 'sans-serif';
  font-size: ${(props) => props.theme.baseFontSize + 22}px;
`;

export const H6 = styled.h6`
  font-weight: bold;
  font-family: Poppins, Helvetica Neue, 'sans-serif';
  font-size: ${(props) => props.theme.baseFontSize + 14}px;
`;

export const P1 = styled.p`
  font-weight: bold;
  font-size: ${(props) => props.theme.baseFontSize + 5}px;
`;
export const P2 = styled.p`
  font-weight: bold;
  font-size: ${(props) => props.theme.baseFontSize}px;
`;

export const Button = styled.button<IProps>`
  display: ${(p) => (p.inline ? 'inline' : 'initial')};
  border-radius: ${(p) => (p.inline ? 0 : 25)}px;
  font-size: ${(p) => p.theme.baseFontSize + 6}px;
  font-weight: bold;
  background-color: ${(props) => props.theme.primary};
  color: #fff;
  width: 165px;
  outline: 0;
  box-shadow: none;
  padding: ${(props) => props.theme.spacer * 2}rem ${(props) => props.theme.spacer * 4}rem;
  border: none;
  cursor: pointer;
  transition: all ease-in-out 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.secondary};
  }
`;
